<header>
    <!--nav -->
    <a [ngClass]="['menu-link', isMenuOpen ? 'menu-open' : '']" (click)="toggleMenu()">
        <span>toggle menu</span>
    </a>
    <nav id="menu" [ngClass]="['panel', isMenuOpen ? 'show' : '']">
        <ul>
            <li *ngFor="let menuItem of menu">
                <a [routerLink]="[menuItem.link]"  (click)="toggleMenu()" routerLinkActive="active"  [routerLinkActiveOptions]="{exact: true}">{{menuItem.text}}</a>
            </li>
        </ul>
    </nav>
    <!-- //nav -->
    <!-- logo -->
    <div class="logo">
        <a [routerLink]= "['']">
            <i class="fab fa-node-js"></i>
        </a>
    </div>
    <!-- //logo -->
</header>